import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { toggleRightSidebarAction } from "../../Store/Actions/AuthActions";

import SpotDetails from "../SpotDetails";
import BookingDetails from "../BookingDetails";

const DetailsRightSidebar = ({
  type = "spot",
  item,
  closeSidebar,
  onUpdated = null,
}) => {
  // const item = dummySpot;
  const dispatch = useDispatch();
  const [isOpen, seIsOpen] = useState(false);

  const toggleSidebar = () => {
    toggleRightSidebarAction(false, dispatch);

    seIsOpen(false);

    setTimeout(() => {
      closeSidebar();
    }, 500);
  };

  useEffect(() => {
    seIsOpen(true);
  }, []);

  return (
    <div className={`right-sidebar ${isOpen ? "open" : ""}`}>
      {type === "spot" && (
        <SpotDetails item={item} title={item.name} onClose={toggleSidebar} />
      )}

      {type === "booking" && (
        <BookingDetails
          item={item}
          title={item.spot.name}
          onClose={toggleSidebar}
          onUpdated={onUpdated}
        />
      )}

      {type === "payments" && (
        <BookingDetails
          item={item}
          title={item.spot.name}
          onClose={toggleSidebar}
          onUpdated={onUpdated}
        />
      )}
    </div>
  );
};

export default DetailsRightSidebar;
